// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface CreateUserRole
 */
export interface CreateUserRole {
  /**
   * @type {number}
   * @memberof CreateUserRole
   */
  user_id: number;
  /**
   * @type {number}
   * @memberof CreateUserRole
   */
  object_id: number;
  /**
   * @type {string}
   * @memberof CreateUserRole
   */
  object_type: CreateUserRoleObjectTypeEnum;
  /**
   * @type {number}
   * @memberof CreateUserRole
   */
  group_id: number;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateUserRoleObjectTypeEnum {
  Event = 'event',
  Organization = 'organization',
}
